var Texture = (function () {
    function Texture() {
    }
    // todo. can probably route directly to awayjs class
    Texture.fromBitmapData = function (bitmapData) {
        console.log("fromBitmapData not implemented yet in flash/Texture");
        return null;
    };
    Texture.prototype.uploadCompressedTextureFromByteArray = function (data, byteArrayOffset, async) {
        if (async === void 0) { async = false; }
        console.log("uploadCompressedTextureFromByteArray not implemented yet in flash/Texture");
    };
    Texture.prototype.uploadFromBitmapData = function (source, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        console.log("uploadFromBitmapData not implemented yet in flash/Texture");
    };
    Texture.prototype.uploadFromByteArray = function (data, byteArrayOffset, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        console.log("uploadFromByteArray not implemented yet in flash/Texture");
    };
    return Texture;
}());
export { Texture };
